module.exports = __webpack_public_path__ + "img/game3.3.c4d26d73.png";